// src/pages/UserManagement.js
import React from "react";

import NavBar from "../components/NavBar/NavBar";
import UserManagement from "../components/UserManagement/UserManagement";

export default function UserPage() {
  return (
    <>
      <NavBar/>
      <main className="web-view">
   <UserManagement />
      </main>
    </>
  );
}
